export const PARTNER_DISPLAY_COLUMNS_STORAGE_KEY = "partner_display_columns";
export const PARTNER_DEFAULT_SEEDED_STORAGE_KEY = "partner_default_seeded";
export const PARTNER_ADVANCED_FILTERS_STORAGE_KEY = "partner_advanced_filters";
export const PARTNER_APPLIED_CONDITION_NAME_STORAGE_KEY = "partner_applied_condition_name";
export const PARTNER_APPLIED_CONDITION_ID_STORAGE_KEY = "partner_applied_condition_id";
export const DEFAULT_PARTNER_LIST_SORT = "createdAt|DESC" as const;
